import { User } from '@types'
import { selectCredentials } from '@views/loginView/state/loginSlice'
import { call, takeEvery, put, select } from 'redux-saga/effects'
import {
  getAllAnalyst,
  getAllCases,
  getAnalystsFailed,
  getAnalystsSuccess,
  getCasesByAnalyst,
  getCasesByAnalystFailed,
  getCasesByAnalystSuccess
} from './analystCasesSlice'
import { getAllAnalystsService, getAnalystCases, getAnalystSelectedCases } from '@http/analystService'
import { PayloadAction } from '@reduxjs/toolkit'

export function* getAllAnalystsSaga() {
  const { cocap } = yield select(selectCredentials)
  try {
    const analysts: User[] = yield call(getAllAnalystsService, cocap)
    yield put(getAnalystsSuccess(analysts))
  } catch (e) {
    yield put(getAnalystsFailed(JSON.stringify(e)))
  }
}

export function* getCasesByAnalystSaga({ payload }: PayloadAction<{ userId: string }>) {
  const { cocap } = yield select(selectCredentials)
  try {
    const cases: User[] = yield call(getAnalystCases, cocap, payload.userId)
    yield put(getCasesByAnalystSuccess(cases))
  } catch (e) {
    yield put(getCasesByAnalystFailed(JSON.stringify(e)))
  }
}

export function* getAllCasesSaga() {
  const { cocap } = yield select(selectCredentials)
  try {
    const cases: User[] = yield call(getAnalystSelectedCases, cocap)
    yield put(getCasesByAnalystSuccess(cases))
  } catch (e) {
    yield put(getCasesByAnalystFailed(JSON.stringify(e)))
  }
}

export default function* commissionsSaga() {
  yield takeEvery(getAllAnalyst.type, getAllAnalystsSaga)
  yield takeEvery(getCasesByAnalyst.type, getCasesByAnalystSaga)
  yield takeEvery(getAllCases.type, getAllCasesSaga)
}
